import React from 'react';

interface Props {
  children: any;
  onClick: any;
  primary?: boolean;
  color?: string;
  fill?: boolean;
  link?: boolean;
  disabled?: boolean;
  width?: string;
  style?: Record<string, any>;
  modalClose?: boolean;
  modalTargetName?: string;
}

export const Button = (props: Props) => {
  const {
    children,
    onClick,
    primary,
    color,
    fill,
    link,
    disabled,
    width,
    style,
    modalClose,
    modalTargetName,
  } = props;

  let className = 'btn-default';
  if (primary) {
    className = 'btn-blue';
  } else if (color) {
    className = `btn-${color}`;
  } else if (link) {
    className = 'btn-link';
  }
  if (width) {
    className += ` btn-width-${width}`;
  }
  if (fill) {
    className += ` btn-fill`;
  }

  return (
    <button
      type="button"
      className={`rms-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
      data-dismiss={modalClose ? 'modal' : ''}
      data-toggle={modalTargetName ? 'modal' : ''}
      data-target={modalTargetName ? `#${modalTargetName}` : ''}
      data-testid="button"
    >
      {children}
    </button>
  );
};
